<template lang="pug">
div
  .fluid__video.single-cinemagraph(
    :class='{ incomplete: status !== "complete" }')
    iframe(:src='flixel.player_url' allow='autoplay')
    a.slideshow__actions.prev(
      v-if='savedList.index',
      @click='skipTo("prev")')
      img(srcset='images/gallery/arrow-left@2x.png 2x, images/gallery/arrow-left.png 1x')
    a.slideshow__actions.next(
      v-if='showNext(savedList)',
      @click='skipTo("next")')
      img(srcset='images/gallery/arrow-right@2x.png 2x, images/gallery/arrow-right.png 1x')

  .h-cover(v-if='status !== "complete"')
    .background.list--shadow.h-textcenter
      p.h-white.h-bold(v-if='status !== "complete" && status !== "failed"') We are processing your cinemagraph.
      p.h-white.h-bold(v-if='status === "failed"') We could not process your cinemagraph. Please try uploading again.
</template>

<script>
import FlixelService from 'services/flixel.es6.js';
import router from '../router';

export default {
  name: 'Single-Flixel',
  props: [
    'flixel',
  ],
  data() {
    return {
      profile: '',
      flixelObj: '',
      savedList: {
        index: '',
      },
      status: '',
      permission: {
        canChangeTargetLink: '',
        privacy: '',
      },
      isOwner: '',
    };
  },
  created() {
    const self = this;
    self.flixelObj = this.flixel;
    self.profile = localStorage.getItem('profile');
    self.status = FlixelService.returnStatus(self.flixelObj.status);
  },
  watch: {
    flixel() {
      this.flixelObj = this.flixel;
      this.status = FlixelService.returnStatus(this.flixelObj.status);
      this.permission.privacy = FlixelService.returnPrivacy(this.flixelObj.privacy);
      this.permission.canChangeTargetLink = this.flixelObj.canChangeTargetLink;
      this.$el.children[0].src = this.flixelObj.src;
      this.isOwner = (!this.profile || this.flixelObj.username !== this.profile.username) ? false : true;
    },
    keydown() {
      $(document).on('keydown', function (e) {
        if (e.keyCode === 37) {
          this.skipTo('prev');
          return false;
        }
        if (e.keyCode === 39) {
          this.skipTo('next');
          return false;
        }
      });
    },
  },
  methods: {
    incrementList(type, list) {
      if (type === 'next') {
        return list.index === list.results.length - 1 ? list.index : list.index + 1;
      } else {
        return list.index ? list.index - 1 : 0;
      }
    },
    showNext(list) {
      if (list.results) {
        return list.index !== list.results.length - 1;
      }
    },
    skipTo(type) {
      const list = FlixelService.savedList;
      list.index = incrementList(type, FlixelService.savedList);
      this.$router.push({ name: 'Flixel', params: { hash: list.results[list.index].hash } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SingleFlixel.vue